import BaseStore from 'fluxible/addons/BaseStore';

class AbStore extends BaseStore {

  constructor(dispatcher) {
    super(dispatcher);
    this.winningVariants = null;
    this.abExperiments = null;
  }

  getAbExperiments() {
    return this.abExperiments;
  }

  getWinningVariants() {
    return this.winningVariants;
  }

  getWinningVariant(experimentName) {
    const winnerVariant =
      this.winningVariants && this.winningVariants.find(e => e.experiment === experimentName);

    if (!winnerVariant) {
      return null;
    }

    return winnerVariant.name;
  }

  handleAbDataLoaded(payload) {
    this.winningVariants = payload.winningVariants;
    this.abExperiments = payload.abExperiments;
    this.emitChange();
  }

  dehydrate() {
    return {
      winningVariants: this.winningVariants,
      abExperiments: this.abExperiments
    };
  }

  rehydrate(state) {
    this.winningVariants = state.winningVariants;
    this.abExperiments = state.abExperiments;
  }
}

AbStore.storeName = 'AbStore';
AbStore.handlers = {
  LOAD_AB_DATA: 'handleAbDataLoaded'
};

export default AbStore;
